import './SimpleSelectQuiz.css';
import questionIcon from '../images/question.png';

const SimpleSelectQuiz = ({
  question,
  options = [],
  selectedAnswer,
  isAnswerChecked,
  onSelectAnswer,
}) => {
  if (!question) {
    return null;
  }

  const handleSelectAnswer = (option) => {
    if (isAnswerChecked) {
      return;
    }

    onSelectAnswer?.(option);
  };

  const getOptionClassName = (option) => {
    if (isAnswerChecked) {
      if (option === question.correctAnswer) {
        return 'simple-Button-select-correct-bc';
      }

      if (option === selectedAnswer) {
        return 'simple-Button-select-incorrect-bc';
      }

      return 'simple-Button-select-bc';
    }

    if (option === selectedAnswer) {
      return 'simple-Button-select-colored-bc';
    }

    return 'simple-Button-select-bc';
  };

  return (
    <div className="quiz-content-scroll-bc">
      <div className="explanation-lesoon-container-bc">
        <div className="tittle-sescrition-lesson title-simple-select-align">
      
            <div className="question-text-bc-external">
                 <img
                    src={questionIcon}
                    alt="Question"
                    className="simple-select-question-icon"
                  />
              <p>{question.question}</p>
            </div>
          
        </div>

        <div className="simple-select-buttons-description">
          {options.map((option, index) => (
            <button
              key={`${String(option)}-${index}`}
              type="button"
              className={getOptionClassName(option)}
              disabled={isAnswerChecked}
              onClick={() => handleSelectAnswer(option)}
            >
              <p>{option}</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SimpleSelectQuiz;